// lib
import React from 'react';

// def
interface CMSProps {
  content: string;
  jsContent: string;
}

const CMSView = ({ content, jsContent }: CMSProps) => {
  if (!content) {
    return null;
  }

  return (
    <>
      <div suppressHydrationWarning={true} dangerouslySetInnerHTML={{ __html: content }} />
      {jsContent && (
        <div suppressHydrationWarning={true} dangerouslySetInnerHTML={{ __html: jsContent }} />
      )}
    </>
  );
};

export default CMSView;
